import { createReducer } from "@reduxjs/toolkit";
import type { RetrievalState } from "@redux/state/shared-types";
import type { StudentVM } from "@shared-kernel/application/ports/student/student-repository";
import { retrieveStudentProfile } from "./retrieve-student-profile";

const initialState: RetrievalState<StudentVM | null> = { fetching: "idle", data: null };

export const retrieveStudentProfileReducer = createReducer<RetrievalState<StudentVM | null>>(initialState, builder => {
  builder.addCase(retrieveStudentProfile.fulfilled, (state, { payload }) => {
    return {
      ...state,
      data: payload,
      fetching: "success",
    };
  });
  builder.addCase(retrieveStudentProfile.pending, state => {
    return {
      ...state,
      fetching: "pending",
    };
  });
  builder.addCase(retrieveStudentProfile.rejected, state => {
    return {
      ...state,
      fetching: "failed",
    };
  });
});
